module.exports = __webpack_public_path__ + "static/media/img_liucheng.916b78f7.png";